import { ImageComponent } from '@/components/Image';
import { ScBadgePills } from './styled';

interface IBadgePillsProps {
  icons: string[];
  items: string[];
}

export const BadgePills = ({ items, icons }: IBadgePillsProps) => (
  <ScBadgePills>
    {items.map((label, i) => (
      <div className="badge" key={label}>
        <ImageComponent
          alt={label}
          height={20}
          src={icons[i] ?? ''}
          width={20}
        />
        <span>{label}</span>
      </div>
    ))}
  </ScBadgePills>
);
